import { LineNameMap, RiskLevelMap, highColor, midColor, lowColor, interceptColor } from "./constants";

const _highColor = highColor.concat(interceptColor)
const _middleColor = midColor.concat(interceptColor)
const _lowColor = lowColor.concat(interceptColor)

const lineColor = (risk_level, index) => {
  if (risk_level === RiskLevelMap.high) {
    return _highColor[index]
  } else if (risk_level === RiskLevelMap.mid) {
    return _middleColor[index]
  } else if (risk_level === RiskLevelMap.low) {
    return _lowColor[index]
  } else {
    return [].concat(highColor[0]).concat(midColor[0]).concat(lowColor[0]).concat(interceptColor[0])[index]
  }
}

export const disposeLineEchart = (risk_level, data) => {
  let result = [];
  Object.keys(data).map((key, index) => {
    result.push({
      name: LineNameMap[key],
      type: "line",
      itemStyle: {
        normal: {
          color: lineColor(risk_level, index),
          lineStyle: {
            color: lineColor(risk_level, index),
            width: 2
          }
        }
      },
      data: data[key],
    });
  })

  return result;
}

export const disposeLineDataTime = (time) => {
  let _t = time.map(i => {
    return i.split("T").join(" ");
  });

  let _i = _t.map(i => {
    return i.split("+")[0];
  });

  return _i
}